export default __webpack_public_path__ + "static/media/news-inner-image.dd66ed23.jpg";